export default __webpack_public_path__ + "static/media/guide_import_3.a23b2109.jpg";